/**
 * Modal de sugestão de solução sobre o detalhe V2 da OS.
 */

import React from 'react';
import { Lightbulb } from 'lucide-react';
import { OrderDetailsV2MenuModal } from './OrderDetailsV2MenuModal';
import '../../process-config/components/DefeitosVerveRichTextContent.css';
export function OrderDetailsSugestaoModal({
  open,
  onClose,
  orderId,
  loadingDefeito,
  defeitoData,
}) {
  const hasSugestao =
    defeitoData && String(defeitoData.auto_solution_suggestions || '').trim();

  return (
    <OrderDetailsV2MenuModal
      open={open}
      onClose={onClose}
      title="Sugestão de solução"
      icon={<Lightbulb size={18} strokeWidth={2} aria-hidden />}
      orderId={orderId}
      titleId="odv2-sugestao-modal-title"
      closeAriaLabel="Fechar sugestão de solução"
      panelClassName="odv2-menu-modal-panel--sugestao"
      bodyClassName="odv2-menu-modal-body--sugestao"
    >
      {loadingDefeito ? (
        <p className="order-details-sugestao-loading">Carregando sugestão…</p>
      ) : hasSugestao ? (
        <div
          className="defeitos-vv-rt-editor order-details-sugestao-html"
          dangerouslySetInnerHTML={{ __html: defeitoData.auto_solution_suggestions }}
        />
      ) : (
        <p className="order-details-sugestao-empty">Nenhuma sugestão cadastrada para este defeito.</p>
      )}
    </OrderDetailsV2MenuModal>
  );
}
